// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomCheckbox_wrapper__G4dJS"};